/**
 * Client-side assessment history — persists tool runs to localStorage
 * so members can review recent scores without backend state.
 * Mirrors the API of the source project's /assessments endpoint.
 */

const KEY = "catalyst.assessments.v1";
const MAX = 200;

export function saveAssessment(record) {
  try {
    const list = readAll();
    const item = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      created_at: new Date().toISOString(),
      ...record,
    };
    list.unshift(item);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    return item;
  } catch {
    return null;
  }
}

export function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function clearAll() {
  localStorage.removeItem(KEY);
}

// Shim that mimics `api.post("/assessments", payload)` used by the ported tool pages.
const assessmentsClient = {
  post: async (path, payload) => {
    if (path === "/assessments") {
      const item = saveAssessment(payload);
      return { data: item };
    }
    throw new Error("Unsupported endpoint in localStorage shim: " + path);
  },
};

export default assessmentsClient;
